module.exports = __webpack_public_path__ + "img/footer-logo.564a48f6.svg";